export const EMAIL = [
  (v) => !!v || "E-mail is required",
  (v) => /.+@.+/.test(v) || "E-mail must be valid",
];
export const EMAIL_OPTIONAL = [
  (v) => !v || /.+@.+/.test(v) || "E-mail must be valid",
];
export const FIELD = [(v) => !!v || "Field is required"];
export const PHONE = [
  (v) => !!v || "Please enter a valid phone number",
  (v) => {
    if (!v) return "Please enter a valid phone number";

    // keep only digits
    const digits = v.replace(/\D/g, "");

    // ✅ Case 1: plain 10-digit US number
    if (digits.length === 10) return true;

    // ✅ Case 2: number with country code (like +1, +91, etc.)
    if (digits.length > 10 && digits.length <= 12) {
      //const localPart = digits.slice(-10); // last 10 digits
      return true;//localPart.length === 10 || "Please enter a valid phone number";
    }

    return "Please enter a valid phone number";
  }
];
export const PASSWORD = [
  (v) => !!v || "Please type password.",
  (v) =>
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(v) ||
    "At least 8 characters, should contain Letters, Numbers and Special Characters",
];
export const REDUCTION_RATE = [
  (v) => !!v || "Field is required",
  (v) => (v <= 99 && v >= 1) || "Percentage should be between 1 to 99",
];
export const PAYOUT_STATUS = [
  (v) => !!v || "Field is required",
  (v) => v === "Paid" || "Field must be Paid",
];
export const COMMISSION_RATIO = [
  (v) => !!v || "Field is required",
  (v) => (v <= 1 && v >= 0) || "Ratio should be between 0 to 1",
];
